import '@babel/polyfill';
import 'whatwg-fetch';

import React from 'react';
import { render } from 'react-dom';
import classNames from 'classnames';

// Paper
import { AppRoot } from '@nackle/deck';
import { Layout } from '@nackle/paper';
const { Content } = Layout;
import { getMiddleware as getRouteMiddleware, routes } from './app-routing.jsx';

// Routing
import { Route, Link, routeHistory } from '@nackle/biw-web-router';

// Shared
//import LocaleSelect from './components/shared/locale-select/locale-select.jsx';
import {
    ChromeIcon,
    EzThanksLogo,
    RecognitionNowIcon,
    RecognitionNowLogo,
    SlackIcon,
    WorkplaceIcon,
    TeamsIcon,
    OutlookIcon
} from './components/shared/icons/icons.jsx';

import './styles/style.less';
const EZ_THANKS_TYPE = 'ezthanks';

const INTEGRATIONS = [ {
    type: 'slack',
    title: 'Slack',
    image: <SlackIcon />
}, {
    type: 'workplace',
    title: 'Workplace',
    image: <WorkplaceIcon />
}, {
    type: 'teams',
    title: 'Teams',
    image: <TeamsIcon />
}, 
 {
    type: 'outlook',
    title: 'Outlook',
    image: <OutlookIcon />
},
{
    type: 'chrome',
    title: 'Chrome',
    image: <ChromeIcon />
} ];

class App extends React.Component {
    state = {
        activeType: location.pathname.split( '/' )[ 1 ] || 'slack'
    }

    render() {
        const {
            activeType
        } = this.state;
        return (
            <Route render={ ( route ) => (
                <AppRoot>
                    <Layout>
                        <header className="header">
                            <div className="wrapper">
                                { activeType === EZ_THANKS_TYPE
                                ?
                                <div className="logoTitleContainer">
                                    <EzThanksLogo />
                                    <span className="title">EZ Thanks</span>
                                </div>
                                :
                                <Link to="/">
                                    <RecognitionNowLogo />
                                </Link>
            }
                                { /* <LocaleSelect /> */ }
                            </div>
                        </header>
                        <Content className="main-content">
                            {
                                route.match && route.match.showTabs && (
                                    <div className="tab-container">
                                        {
                                            INTEGRATIONS.map( i => (
                                                <a
                                                    key={ i.type }
                                                    className="tab"
                                                    href={ `#${ i.type }` }
                                                    onClick={ this.handleClick( i.type ) }
                                                >
                                                    <span className="icon">
                                                        { i.image }
                                                    </span>
                                                    <span className="title">{ i.title }</span>
                                                    <span
                                                        className={ classNames(
                                                            'underline', {
                                                                active: activeType === i.type
                                                            } )
                                                        }
                                                    />
                                                </a>
                                            ) )
                                        }
                                    </div>
                                )
                            }
                            {
                                route.match ? (
                                    route.component
                                ) : (
                                    null
                                )
                            }
                        </Content>
                    </Layout>
                    { activeType !== EZ_THANKS_TYPE &&
                    <div className="footer">
                        <div className="wrapper">
                            <RecognitionNowIcon />
                            <Link to="/terms-and-conditions">
                                Terms & Conditions
                            </Link>
                            <Link to="/privacy">
                                Privacy Policy
                            </Link>
                            <span className="copyright">
                                { `©${ new Date().getFullYear() } BI WORLDWIDE. All Rights Reserved.` }
                            </span>
                        </div>
                    </div>
            }
                </AppRoot>
            ) } />
        );
    }

    handleClick = ( type ) => ( e ) => {
        e.preventDefault();

        this.setState( { activeType: type }, () => {
            routeHistory.push( `/${ type }` );
        } );
    }
}

routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( getRouteMiddleware() );

render( <App />, document.getElementById( 'app-root' ) );
